import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { reportService } from "../../../apis/apiServices/Report";
import moment from "moment";
import { Template } from "devextreme-react";
import { AssetSubStatus, DefaultDateFormat } from "../../../helper/fixcode";
import { Loader } from "../../Shared/PageLoader";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";
import Modal from "react-modal";

export default function ReportAssetAcknowledgementComponent(props) {
  const user = useSelector((state) => state.user.data);
  const [assetAcknowledgementList, setAssetAcknowledgementList] = useState([]);
  const [rowData, setRowData] = useState(null);
  const [isAcknowledgeModalOpen, setIsAcknowledgeModalOpen] = useState(false);
  const refDataGrid = useRef(null);
  const [state, setState] = useState({
    isCompleteLoading: false,
    loadingMessage: "Loading Report...",
  });

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Acknowledgement`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      await getAssetAcknowledgementList(0, user?.userId);
    } catch (error) {
      console.log(error);
    } finally {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getAssetAcknowledgementList = async (assetAcknowledgeId, userId) => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await reportService.getAssetAcknowledgementList(
        assetAcknowledgeId,
        userId
      );
      setAssetAcknowledgementList(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <DataGrid
                  ref={refDataGrid}
                  keyExpr="id"
                  dataSource={assetAcknowledgementList}
                  showColumnLines={false}
                  showRowLines={true}
                  showBorders={true}
                  allowColumnResizing={false}
                  allowColumnReordering={true}
                  columnAutoWidth={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarRefreshTemplate",
                    });
                  }}
                >
                  <Column
                    dataField="id"
                    width={170}
                    caption=""
                    allowExporting={false}
                    allowFiltering={false}
                    allowSearch={false}
                    allowSorting={false}
                    cellRender={(cellData) => {
                      return (
                        <>
                          <div style={{ display: "flex" }}>
                            <span>
                              <button
                                style={{ cursor: "pointer" }}
                                type="button"
                                title="Acknowledge"
                                className="btn btn-primary btn-sm-1"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setIsAcknowledgeModalOpen(true);
                                  setRowData(cellData?.data ?? null);
                                }}
                              >
                                <Icon
                                  className="iconify-size mr-1"
                                  icon="ph:check-fill"
                                  width="14"
                                  height="14"
                                />
                                &nbsp;Acknowledged
                              </button>
                            </span>
                          </div>
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="actionTypeName"
                    caption="Source"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="acknowledgeIndentNo"
                    caption="Asset Acknowledge Indent No"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="assetRequestSubNo"
                    caption="Asset Request No"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="referenceNo"
                    caption="Order No"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="acknowledgeDate"
                    caption="Acknowledgement Date"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    dataType="date"
                    format={DefaultDateFormat.GridDayMonthYearDateFormat}
                  />
                  <Column
                    dataField="allocatedAssetName"
                    caption="Asset Description"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    calculateCellValue={(data) => {
                      return `${data?.allocatedAssetName || ""} ${
                        data?.allocatedAssetSerialNo || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.allocatedAssetName ?? ""}</span>
                          {data?.data?.allocatedAssetSerialNo && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.allocatedAssetSerialNo ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="categoryName"
                    caption="Category"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    calculateCellValue={(data) => {
                      return `${data?.categoryName || ""} ${
                        data?.subCategoryName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.categoryName ?? ""}</span>
                          {data?.data?.subCategoryName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.subCategoryName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="vseFleetId"
                    caption="VSE Fleet Id"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="fromUserFullName"
                    caption="From"
                    visible={false}
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromUserFullName || ""} ${
                        data?.fromUserFullName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromUserFullName ?? ""}</span>
                          {data?.data?.fromDepartment && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.fromDepartment ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="toUserFullName"
                    caption="To"
                    visible={false}
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    calculateCellValue={(data) => {
                      return `${data?.toUserFullName || ""} ${
                        data?.toDepartment || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.toUserFullName ?? ""}</span>
                          {data?.data?.toDepartment && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toDepartment ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="fromProjectName"
                    caption="Project"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromProjectName || ""} ${
                        data?.toProjectName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromProjectName ?? ""}</span>
                          {data?.data?.toProjectName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toProjectName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="transportationName"
                    caption="Transportation Type"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="transportVehicleNo"
                    caption="Vehicle No."
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="transportVendorName"
                    caption="Vendor Name"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    visible={false}
                  />
                  <Column
                    dataField="statusName"
                    caption="Status"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    cellRender={(e) => {
                      let color = "";
                      if (
                        e.data?.statusId ===
                        Number(AssetSubStatus.AssetAcknowledgePending)
                      ) {
                        color = "#afad1eff";
                      } else if (
                        e.data?.statusId ===
                        Number(AssetSubStatus.AssetAcknowledged)
                      ) {
                        color = "#16b36aff";
                      }
                      return (
                        <div>
                          <span style={{ color }}>{e.data?.statusName}</span>
                        </div>
                      );
                    }}
                  />
                  <Column
                    dataField="createdDate"
                    caption="Created On"
                    allowSearch={true}
                    allowFiltering={false}
                    calculateCellValue={(data) => {
                      return `${data?.createdDate || ""} ${
                        data?.createdByUserFullName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      if (data?.data?.createdDate) {
                        return (
                          <>
                            <span>
                              {moment(data?.data?.createdDate).format(
                                "DD/MM/YYYY"
                              ) +
                                " " +
                                moment(data?.data?.createdDate).format("LT") ??
                                ""}
                            </span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.createdByUserFullName ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Column
                    dataField="updatedDate"
                    caption="Last updated"
                    allowSearch={true}
                    allowFiltering={false}
                    calculateCellValue={(data) => {
                      return `${data?.updatedDate || ""} ${
                        data?.updatedByUserFullName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      if (data?.data?.updatedDate) {
                        return (
                          <>
                            <span>
                              {moment(data?.data?.updatedDate).format(
                                "DD/MM/YYYY"
                              ) +
                                " " +
                                moment(data?.data?.updatedDate).format("LT") ??
                                ""}
                            </span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.updatedByUserFullName ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Template
                    name="toolbarRefreshTemplate"
                    render={() => {
                      return (
                        <>
                          <button
                            style={{ cursor: "pointer" }}
                            type="button"
                            title="Refresh"
                            className="btn btn-outline-primary btn-sm"
                            onClick={async () => {
                              try {
                                setState((prevState) => ({
                                  ...prevState,
                                  isCompleteLoading: true,
                                }));
                                await getAssetAcknowledgementList(
                                  0,
                                  user?.userId
                                );
                              } catch (error) {
                                console.log(error);
                              } finally {
                                setState((prevState) => ({
                                  ...prevState,
                                  isCompleteLoading: false,
                                }));
                              }
                            }}
                          >
                            <i className="fas fa-sync-alt"></i>
                            &nbsp;&nbsp;Refresh
                          </button>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={false} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Paging defaultPageSize={10} />
                  <Pager
                    allowedPageSizes={[10, 15, 20, 50, 100]}
                    showPageSizeSelector={true}
                    showInfo={true}
                    visible={true}
                    showNavigationButtons={true}
                  />
                  <Export enabled={true} fileName="Asset Acknowledgement" />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* For Acknowledging Asset */}
      <Modal
        ariaHideApp={false}
        isOpen={isAcknowledgeModalOpen}
        className={"react-modal custom-modal-xlarge"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Acknowledge Asset"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {`Acknowledge Asset - [${rowData?.acknowledgeIndentNo}] for ${rowData?.actionTypeName}`}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              setIsAcknowledgeModalOpen(false);
              setRowData(null);
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div
            style={{ overflowy: "auto", height: "600px", overflowX: "hidden" }}
          >
            {" "}
            <div className="row">
              <div className="col-12 col-lg-3">
                <div className="form-group mb-3">
                  <label className="mb-0">Order No</label>
                  <p className="labelvalue">
                    {!rowData?.referenceNo ? "NA" : rowData?.referenceNo}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Asset Name</label>
                  <p className="labelvalue">
                    {!rowData?.allocatedAssetName
                      ? "NA"
                      : rowData?.allocatedAssetName}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Asset Serial No</label>
                  <p className="labelvalue">
                    {!rowData?.allocatedAssetSerialNo
                      ? "NA"
                      : rowData?.allocatedAssetSerialNo}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Group</label>
                  <p className="labelvalue">
                    {!rowData?.assetGroupName ? "NA" : rowData?.assetGroupName}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Category</label>
                  <p className="labelvalue">
                    {!rowData?.categoryName ? "NA" : rowData?.categoryName}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Sub Category</label>
                  <p className="labelvalue">
                    {!rowData?.subCategoryName
                      ? "NA"
                      : rowData?.subCategoryName}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">VSE Fleet Id</label>
                  <p className="labelvalue">
                    {!rowData?.vseFleetId ? "NA" : rowData?.vseFleetId}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">ERP Fleet Id</label>
                  <p className="labelvalue">
                    {!rowData?.erpFleetId ? "NA" : rowData?.erpFleetId}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Project</label>
                  <p className="labelvalue">
                    {!rowData?.assetProjectName
                      ? "NA"
                      : rowData?.assetProjectName}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Location</label>
                  <p className="labelvalue">
                    {!rowData?.locationName ? "NA" : rowData?.locationName}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Make</label>
                  <p className="labelvalue">
                    {!rowData?.assetMake ? "NA" : rowData?.assetMake}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Make Year</label>
                  <p className="labelvalue">
                    {!rowData?.assetMakeYear ? "NA" : rowData?.assetMakeYear}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Model</label>
                  <p className="labelvalue">
                    {!rowData?.assetModel ? "NA" : rowData?.assetModel}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Model Serial No</label>
                  <p className="labelvalue">
                    {!rowData?.assetModelModelSerialNo
                      ? "NA"
                      : rowData?.assetModelModelSerialNo}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  <label className="mb-0">Size</label>
                  <p className="labelvalue">
                    {!rowData?.assetSize ? "NA" : rowData?.assetSize}
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <label>
                    Received By&nbsp;<span className="text-danger">*</span>
                  </label>
                  <p className="labelvalue">
                    {rowData?.acknowledgedByUserFullName === ""
                      ? "NA"
                      : rowData?.acknowledgedByUserFullName}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <label>
                    Asset Status&nbsp;<span className="text-danger">*</span>
                  </label>
                  <p className="labelvalue">
                    {rowData?.acknowledgedAssetStatusName === ""
                      ? "NA"
                      : rowData?.acknowledgedAssetStatusName}
                  </p>
                </div>
              </div>

              <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <div>File Uploaded</div>
                  <a
                    style={{
                      cursor: "pointer",
                      color: "blue",
                      textAlign: "center",
                    }}
                    onClick={() => {
                      try {
                        let a = document.createElement("a");
                        a.href = rowData?.assetAcknowledgeFileUrl;
                        a.download = rowData?.assetAcknowledgeFileName;
                        a.target = "_blank";
                        a.click();
                        document.body.removeChild(a);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    <u>{rowData?.assetAcknowledgeFileName}</u>
                  </a>
                </div>
              </div>
            </div>
            {(rowData?.actionTypeId === 1 ||
              rowData?.actionTypeId === 2 ||
              rowData?.actionTypeId === 3) && (
              <>
                <br />
                <h6>
                  Custodian Information
                  <hr style={{ borderTop: "1px solid rgb(223 211 211)" }}></hr>
                </h6>
                <div className="row">
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>
                        Department (Custodian 1)&nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <p className="labelvalue">
                        {rowData?.custodian1DeptName === ""
                          ? "NA"
                          : rowData?.custodian1DeptName}
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>
                        Custodian 1&nbsp;<span className="text-danger">*</span>
                      </label>
                      <p className="labelvalue">
                        {rowData?.custodian1UserFullName === ""
                          ? "NA"
                          : rowData?.custodian1UserFullName}
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>
                        Department (Custodian 2)&nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <p className="labelvalue">
                        {rowData?.custodian2DeptName === ""
                          ? "NA"
                          : rowData?.custodian2DeptName}
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>
                        Custodian 2&nbsp;<span className="text-danger">*</span>
                      </label>
                      <p className="labelvalue">
                        {rowData?.custodian2UserFullName === ""
                          ? "NA"
                          : rowData?.custodian2UserFullName}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>
                        Department (Custodian 3)&nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <p className="labelvalue">
                        {rowData?.custodian3DeptName === ""
                          ? "NA"
                          : rowData?.custodian3DeptName}
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>
                        Custodian 3&nbsp;<span className="text-danger">*</span>
                      </label>
                      <p className="labelvalue">
                        {rowData?.custodian3UserFullName === ""
                          ? "NA"
                          : rowData?.custodian3UserFullName}
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-3">
                    <div className="form-group mb-2">
                      <label>
                        Assign To&nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <p className="labelvalue">
                        {rowData?.assignTypeId === 1
                          ? "Department"
                          : rowData?.assignTypeId === 2
                          ? "User"
                          : rowData?.assignTypeId === 3
                          ? "Vendor"
                          : "NA"}
                      </p>
                    </div>
                  </div>
                  {(rowData?.assignTypeId === 1 ||
                    rowData?.assignTypeId === 2) && (
                    <>
                      <div className="col-12 col-lg-3">
                        <div className="form-group mb-2">
                          <label>
                            Department&nbsp;
                            <span className="text-danger">*</span>
                          </label>
                          <p className="labelvalue">
                            {rowData?.assignDeptName === ""
                              ? "NA"
                              : rowData?.assignDeptName}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-3">
                        <div className="form-group mb-2">
                          <label>
                            User&nbsp;<span className="text-danger">*</span>
                          </label>
                          <p className="labelvalue">
                            {rowData?.assignUserFullName === ""
                              ? "NA"
                              : rowData?.assignUserFullName}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                  {rowData?.assignTypeId === 3 && (
                    <>
                      <div className="col-12 col-lg-3">
                        <div className="form-group mb-2">
                          <label>
                            Vendor&nbsp;<span className="text-danger">*</span>
                          </label>
                          <p className="labelvalue">
                            {rowData?.vendorCompanyName === ""
                              ? "NA"
                              : rowData?.vendorCompanyName}
                          </p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-3">
                        <div className="form-group mb-2">
                          <label>
                            vendor Name&nbsp;
                            <span className="text-danger">*</span>
                          </label>
                          <p className="labelvalue">
                            {rowData?.assignVendorName === ""
                              ? "NA"
                              : rowData?.assignVendorName}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group mb-2">
                  <label>
                    Note&nbsp;<span className="text-danger">*</span>
                  </label>
                  <p className="labelvalue">
                    {rowData?.acknowledgedNote === ""
                      ? "NA"
                      : rowData?.acknowledgedNote}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              setIsAcknowledgeModalOpen(false);
              setRowData(null);
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
